import { takeEvery, put, call, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, NOTIFICATION_FAILURE, NOTIFICATION_REQUEST, NOTIFICATION_SUCCESS, REFRESH_SESSION, REFRESH_SESSION_FAILURE, REFRESH_SESSION_SUCCESS, SOCIAL_LOGIN,USER_MENU_DETAILS_REQUEST } from "./actionTypes"
import { loginSuccess, logoutUserSuccess, apiError,setUnitDetails,userMenuDetailsSuccess,userMenuDetailsFailure } from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper"

import {get,post,update,del} from "../../../helpers/api_helper"

import {AccessRights} from "../../../common/data/constants"
import { encryptData } from "../../../helpers/crypto_helper";
import Swal from "sweetalert2"

const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      )
      yield put(loginSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      })
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      // const response = yield call(postFakeLogin, {
      //   email: user.email,
      //   password: user.password,
      // })

      // localStorage.setItem("authUser", encryptData(JSON.stringify(response)))
      // const accessRightList = AccessRights.filter(accessRight => accessRight.role_code === "U001");
      // localStorage.setItem("accessRights", encryptData(JSON.stringify(accessRightList)));
      // yield put(loginSuccess(response))

      // console.log('user > ',user)
      const formData = new FormData();
      formData.append('user_id', user.email);
      formData.append('password', user.password);

      const response = yield call(post, process.env.REACT_APP_LOGIN_API, formData, {});
      
      // const access_Rights = response.data.access_Rights;
      // const role_details = response.data.role_details;
      // console.log('access_Rights > ',access_Rights)
      // const accessRightList = access_Rights.filter(accessRight => accessRight.role_code === role_details[0].role_code);
      // localStorage.setItem("accessRights", JSON.stringify(accessRightList));
      // localStorage.setItem("accessRights", JSON.stringify(response.data.access_Rights))
      // yield put(loginSuccess(response))
      
      if (response.status === 'success') {
        yield put(apiError(""));
        // localStorage.setItem("authUser", encryptData(JSON.stringify(response)))
        // const accessRightList = AccessRights.filter(accessRight => accessRight.role_code === "U001");
        // localStorage.setItem("accessRights", encryptData(JSON.stringify(accessRightList)));
        yield put(setUnitDetails(response.data.unit_details));
        yield put(loginSuccess(response));
      } else {
        yield put(setUnitDetails([]));
        throw new Error(response.message || 'Login failed');
      }      
    }
    // history.push("/dashboard")
  }  catch (error) {
    let errorMessage = "An unexpected error occurred";
    
    if (error.response) {
      // Capture 500 errors and display a proper message
      if (error.response.status === 500) {
        errorMessage = "Internal Server Error. Please try again later.";
      } else if (error.response.status === 502) {
        errorMessage = "502 Bad Gateway. Server is currently unavailable.";
      } else {
        errorMessage = error.response.statusText || "Login failed";
      }
    } else {
      errorMessage = error.message || "Login failed";
    }
  
    yield put(apiError(errorMessage)); // Dispatch failure action with an error message
  }
}

function* logoutUser({ payload: { history,reason } }) {
  try {
    // Always clear ticker closed state on logout
    localStorage.removeItem("tickerClosed");
    if (reason === "session_expired") {
      localStorage.removeItem("authUser");
      localStorage.removeItem("accessRights");
      localStorage.removeItem("unit_id");
    }   

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout)
      yield put(logoutUserSuccess(response))
    }
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type
      )
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else {
      const response = yield call(postSocialLogin, data)
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    history.push("/dashboard")
  } catch (error) {
    yield put(apiError(error))
  }
}

// Saga function to handle the validation
function* userMenuDetailsSaga({ payload: { user, history }}) {
  try {
    const { user_id, unit_id,landing_page } = user;
    console.log('landing_page > ',landing_page)
    const formData = new FormData();
    formData.append('user_id', user_id);
    formData.append('unit_id', unit_id);

    const response = yield call(post, process.env.REACT_APP_USER_MENU_DETAILS, formData, {});
    localStorage.setItem("unit_id", unit_id)
    yield put(userMenuDetailsSuccess(response.data));
    history.push(`${landing_page}`)
  } catch (error) {
    // If there's an error, dispatch the failure action
    yield put(userMenuDetailsFailure(error.response.data));
  }
}

function* notificationSaga({ payload }) {
  try {
    const response = yield call(
      post,
      process.env.REACT_APP_EMPLOYEE_NOTIFICATION,
      payload
    );

    yield put({ type: NOTIFICATION_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({
      type: NOTIFICATION_FAILURE,
      payload: error.response?.data || "Something went wrong",
    });
  }
}

function* refreshSessionSaga({payload}) {
  try {
    const token = localStorage.getItem("authToken"); // Or get from state/store
    const response = yield call(post, process.env.REACT_APP_REFRESH_SESSION, payload);
    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to refresh session!');
    }
    const accessRightList = response.data?.access_Rights;
    const modules = response.data?.menu_list;
    localStorage.setItem("accessRights", encryptData(JSON.stringify(accessRightList)));
    localStorage.setItem("modules", encryptData(JSON.stringify(modules)));
    yield put({ type: REFRESH_SESSION_SUCCESS, payload: { token: response } });    
    // Swal.fire('Success', 'Session refreshed successfully!', 'success');
  } catch (error) {
    // Swal.fire('Error', error.message, 'error');
    yield put({ type: REFRESH_SESSION_FAILURE, payload: error });
  }
}



function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
  yield takeLatest(USER_MENU_DETAILS_REQUEST, userMenuDetailsSaga);
  yield takeLatest(NOTIFICATION_REQUEST, notificationSaga);
  yield takeLatest(REFRESH_SESSION, refreshSessionSaga);
}

export default authSaga
